import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const routes = [
    { path: '/',redirect: '/login' },
    { path: '/login', component: () => import('@/components/Login.vue') },
    { path:"/403", component: () => import('@/components/403.vue') },
    { path:"*", component: () => import('@/components/404.vue') }
    // {path: "*",redirect: "/login"}
];

export const router = new Router({
    routes: routes
});


export const resetRouter = function() {
    const newRouter = new Router({
        routes
    });
    router.matcher = newRouter.matcher; // 重置路由器
}